module.exports = {
    "id": "bam-brew",
    "character-image": "/provision/projects/bam-brew/bam.png",
    "title": "Bam's Brew",
    "project_file": "bam-brew.gbp",
    "thumbnail": "/provision/projects/bam-brew/bam-brew.png",
    "category": "games",
    "toolbar":{
      "glitches":[],
      "parts":[]
    }
  }
  ;